<template>
  <b-modal
    id="change-student-class"
    ref="changeStudentClass"
    title="Chuyển đổi lớp học"
    size="lg"
    :ok-title="isSubmitting ? 'Đang cập nhật' : 'Cập nhật'"
    :ok-disabled="isSubmitting"
    cancel-title="Huỷ"
    cancel-variant="outline-secondary"
    @show="resetModal"
    no-close-on-backdrop
    @hidden="resetModal"
    @ok="onModalSubmit"
  >
    <b-form>
      <b-row>
        <!-- Cột trái -->
        <b-col cols="12" md="6">
          <select-school v-model="fromSchool" />
          <select-class
            v-model="fromClass"
            label="Lớp học"
            required
            :school="fromSchool"
          />
        </b-col>

        <!-- Cột phải -->
        <b-col cols="12" md="6">
          <select-school v-model="toSchool" />
          <select-class
            enableDropOut
            v-model="toClass"
            label="Lớp học"
            required
            :school="toSchool"
          />
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>
<script>
import {
  BModal,
  BRow,
  BCol,
  BForm
} from 'bootstrap-vue'
import SelectSchool from '@/views/components/SelectSchool.vue';
import SelectClass from '@/views/components/SelectClass.vue';
import useChangeClassModal from './useChangeClassModal';

export default {
  components: {
    BModal,
    SelectClass,
    SelectSchool,
    BRow,
    BCol,
    BForm
  },
  setup(props,{ emit }){

    const {
      fromClass,
      toClass,
      fromSchool,
      toSchool,
      resetModal,
      onSubmit,
      isSubmitting
    } = useChangeClassModal(emit)
    return {
      fromClass,
      toClass,
      fromSchool,
      toSchool,
      resetModal,
      onSubmit,
      isSubmitting
    }
  },
  methods: {
    async onModalSubmit(bvModalEvt){
     await this.onSubmit(bvModalEvt)
     this.$refs['changeStudentClass'].hide()
    }
  }
}
</script>
